import React from "react";
import {SharedViewLogoType} from "../../../core/modules/shared-views/types";

type Props = {
    logo        : SharedViewLogoType,
    className?  : string
}

export function SharedViewLogoTopPanel(props:Props) {

    const onClick = () => {
        window.location.href = "https://www.goodday.work";
    }

    switch (props.logo) {
        case SharedViewLogoType.COMPANY :
            return (
                <div className={Classes("shared-view-logo-company",props.className)} onClick={onClick}>
                    <img src={"{0}company/large/{1}".f(gdConfig.mediaPath, gd.company.icon)}/>
                </div>
            )

        case SharedViewLogoType.NONE    :
            return null

        case SharedViewLogoType.GOODDAY :
        default                         :

            return (
                <div className={Classes("shared-view-logo",props.className)} onClick={onClick} />
            )

    }




    // gd.modules.sharedViews.logo ....



}